import React from 'react';
import PropTypes from 'prop-types';
import QuickUpdatableComponent from './QuickUpdatableComponent';
import TextInput from './TextInput';


class CashInput extends QuickUpdatableComponent {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(evt) {
        const { allowFloat = true } = this.props;
        let oldValue = evt.target.value || '';
        let newValue = '';
        let hasPeriod = -1;
        if (allowFloat) {
            for (let i = 0; i < oldValue.length; i++) {
                if (hasPeriod < 0) {
                    if (oldValue[i] >= '0' && oldValue[i] <= '9') {
                        newValue += oldValue[i];
                    } else if (oldValue[i] === '.') {
                        hasPeriod = i;
                        newValue += oldValue[i];
                    }
                } else {
                    if (i > hasPeriod + 2) {
                        break;
                    }
                    if (oldValue[i] >= '0' && oldValue[i] <= '9') {
                        newValue += oldValue[i];
                    }
                }
            }
        } else {
            for (let i = 0; i < oldValue.length; i++) {
                if (oldValue[i] >= '0' && oldValue[i] <= '9') {
                    newValue += oldValue[i];
                }
            }
        }

        evt.target.value = newValue;
        if (this.props.onChange) {
            this.props.onChange(evt);
        }

        if (this.props.field.onChange) {
            this.props.field.onChange(evt);
        }

        if (this.props.onChanged) {
            this.props.onChanged(evt);
        }
    }

    render() {
        return (
            <TextInput
                {...this.props}
                onChange={this.onChange}
                inputBeforeAddonStyle={{ paddingRight: 5, paddingLeft: 0 }}
                beforeAddon={(<span style={{fontWeight: 'bold'}}>$</span>)}
                afterAddon={this.props.afterAddon}
            />
        );
    }
};

CashInput.propTypes = {
    field: PropTypes.object.isRequired,
    afterAddon: PropTypes.object,
    allowFloat: PropTypes.bool,
};

export default CashInput;